import Layout from "@/layout";
export default {
  meta: {
    title: "服务",
    icon: "b-ff",
  },
  path: "/serveManage",
  component: Layout,
  children: [
    {
      path: "/serveManage/index",
      name: "serveManage",
      component: () => import("@/views/insuresafe/serveManage/index.vue"),
      meta: {
        title: "服务任务",
        auth: [],
        img: "ff",
      },
    },
    {
      path: "/serveManage/detailOther",
      name: "serveManageDetailOther",
      hide: true,
      component: () => import("@/views/insuresafe/serveManage/detailOther.vue"),
      meta: {
        title: "保单管理",
        auth: [],
        img: "azx",
      },
      props: (route) => {
        return route.query;
      },
    },
    {
      path: "/serveManage/detail",
      name: "serveManageDetail",
      hide: true,
      component: () => import("@/views/insuresafe/serveManage/detail.vue"),
      meta: {
        title: "服务详情",
        auth: [],
        img: "azx",
      },
      props: (route) => {
        return route.query;
      },
    },
  ],
};
